import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

// === router ===
import { BrowserRouter } from 'react-router-dom';

// === styles ===
import './index.css';


// === gql ===
import { Provider as UrqlProvider } from 'urql';
import { client } from './graphql/client';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <UrqlProvider value={client}>
        <App />
      </UrqlProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
